'use es6';

import Immutable from 'immutable';
import ThinListing from 'ecosystem-marketplace-core/records/ThinListing';
import * as ecosystemClient from '../clients/ecosystemClient';
import * as ActionTypes from './ActionTypes';
export const fetchMoreApps = (language, moreAppsQueries, slug) => dispatch => {
  dispatch({
    type: ActionTypes.DETAILS_MORE_APPS_FETCH_REQUESTED
  });
  ecosystemClient.searchApps({
    language,
    queries: moreAppsQueries
  }).then(({
    results: [{
      items: _categoryResults
    }, {
      items: _superCategoryResults = []
    } = {}]
  }) => {
    const categoryResults = _categoryResults.filter(({
      slug: _slug
    }) => _slug !== slug);
    const superCategoryResults = _superCategoryResults.filter(({
      slug: _slug
    }) => _slug !== slug);
    const hasCategoryResults = !!categoryResults.length;
    const results = hasCategoryResults ? categoryResults : superCategoryResults;
    dispatch({
      type: ActionTypes.DETAILS_MORE_APPS_FETCH_RECEIVED,
      payload: new Immutable.Map({
        hasCategoryResults,
        results: Immutable.OrderedSet(results.slice(0, 3).map(result => new ThinListing(result)))
      })
    });
  }).catch(__error => {
    dispatch({
      type: ActionTypes.DETAILS_MORE_APPS_FETCH_FAILED
    });
  });
};
export const resetMoreApps = () => dispatch => {
  dispatch({
    type: ActionTypes.DETAILS_MORE_APPS_RESET
  });
};
export const setDetailsReferrer = referrer => dispatch => {
  dispatch({
    type: ActionTypes.DETAILS_REFERRER_SET,
    payload: referrer
  });
};
export const resetDetailsReferrer = () => dispatch => {
  dispatch({
    type: ActionTypes.DETAILS_REFERRER_RESET
  });
};